import { LogisticFilialStatus } from 'models/logistic-filial'

export const LOGISTIC_FILIAL_STATUS_TEXT: Record<LogisticFilialStatus, string> =
  {
    [LogisticFilialStatus.waiting]: 'В ожидании',
    [LogisticFilialStatus.denied]: 'Отклонено',
    [LogisticFilialStatus.in_process]: 'В работе',
    [LogisticFilialStatus.given]: 'Закрыто',
    [LogisticFilialStatus.accepted]: 'Карта запрошена',
    [LogisticFilialStatus.for_delivery]: 'Карта на доставке',
    [LogisticFilialStatus.no_accepted]: 'Отказ от доставки',
  }
